import { render, staticRenderFns } from "./DetailSellStock.vue?vue&type=template&id=2c2ccad6&scoped=true&"
import script from "./DetailSellStock.vue?vue&type=script&lang=js&"
export * from "./DetailSellStock.vue?vue&type=script&lang=js&"
import style0 from "./DetailSellStock.vue?vue&type=style&index=0&id=2c2ccad6&scoped=true&lang=css&"
import style1 from "./DetailSellStock.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c2ccad6",
  null
  
)

export default component.exports